import { MailSettingsInstance } from 'plugin-reports-maker/webapp/js/common/types/api/report'
import {
    getFrequencyMailSettingsInstance,
    getNameMailSettingsInstance,
    getScheduleMailSettingsInstance,
    getStatusMailSettingsInstance
} from './helper'
import { ActionTypesReducer } from './ScheduleContext'

// 'Schedule Name', 'Type', 'Execution', 'Status'
export const SCHEDULE_HEADER = [
    {
        getValue: getNameMailSettingsInstance,
        label: 'Schedule Name'
    },
    {
        getValue: getScheduleMailSettingsInstance,
        label: 'Type'
    },
    {
        getValue: getFrequencyMailSettingsInstance,
        label: 'Execution'
    },
    {
        getValue: getStatusMailSettingsInstance,
        label: 'Status'
    }
] as {
    getValue: (
        settings: MailSettingsInstance,
        onChange: (newSettings: MailSettingsInstance) => void
    ) => string | JSX.Element
    label: string
}[]

const store = {
    isReady: false,
    bufferEvents: [] as ActionTypesReducer[],
    dispatch: function (param: ActionTypesReducer) {
        this.bufferEvents.push(param)
        console.warn(`store schedule actions: is not ready`)
    } as React.Dispatch<ActionTypesReducer>,
    init: function ({ dispatch }) {
        if (this.isReady) return
        this.isReady = true
        this.dispatch = dispatch
        this.bufferEvents.map(event => dispatch(event))
        // this.bufferEvents = []
        Object.freeze(this)
    }
}

export { store }
